(function () {
  "use strict";

  if (!document.body || document.body.dataset.seasonalTheme !== "halloween") return;
  if (!document.querySelector(".pc-halloween-svg-library")) return;

  var main = document.querySelector("#MainContent");
  if (!main) return;

  var viewBoxes = {
    ghost: "0 0 100 110",
    web: "0 0 120 120",
    spider: "0 0 80 100",
    cat: "0 0 120 100",
    pumpkin: "0 0 110 100",
    witch: "0 0 150 100",
    bat: "0 0 120 70",
    cauldron: "0 0 120 110",
    potion: "0 0 90 110"
  };

  var backgroundSlots = [
    { left: "-5%", top: "-32px", x: "-90px", y: "-52px", rotate: "-12deg" },
    { right: "-6%", top: "12%", x: "90px", y: "-38px", rotate: "12deg" },
    { left: "4%", bottom: "-32px", x: "-70px", y: "65px", rotate: "9deg" },
    { right: "2%", bottom: "12%", x: "72px", y: "55px", rotate: "-10deg" }
  ];
  var foregroundSlots = [
    { left: "clamp(-105px,-12vw,-36px)", top: "30%", x: "-65px", y: "-22px", rotate: "-14deg" },
    { right: "clamp(-105px,-12vw,-36px)", bottom: "8%", x: "65px", y: "35px", rotate: "14deg" }
  ];
  var heroForegroundSlots = [
    { right: "clamp(-100px,-10vw,-28px)", top: "7%", x: "70px", y: "-34px", rotate: "13deg" },
    { right: "clamp(-90px,-8vw,-24px)", top: "42%", x: "72px", y: "30px", rotate: "-12deg" }
  ];
  var productForegroundSlots = [
    { left: "clamp(-108px,-13vw,-38px)", top: "10%", x: "-72px", y: "-28px", rotate: "-13deg" },
    { left: "clamp(-100px,-12vw,-36px)", top: "46%", x: "-68px", y: "30px", rotate: "12deg" }
  ];
  var ribbonForegroundSlots = [
    { right: "38%", top: "-12%", x: "44px", y: "-22px", rotate: "12deg" }
  ];

  var recipes = {
    hero: ["ghost", "web", "bat", "witch", "pumpkin", "spider"],
    credibility: ["bat", "ghost", "web"],
    promo: ["web", "ghost", "potion", "bat", "cauldron", "spider"],
    concern: ["cat", "pumpkin", "web", "ghost", "bat", "spider"],
    banner: ["web", "spider", "ghost", "pumpkin", "bat", "cauldron"],
    productsA: ["bat", "potion", "cat", "pumpkin", "web", "ghost"],
    productsB: ["ghost", "witch", "spider", "cauldron", "bat", "potion"],
    brands: ["cat", "ghost", "bat", "web", "potion", "witch"],
    spotlight: ["pumpkin", "cauldron", "ghost", "web", "potion", "bat"],
    ingredient: ["potion", "spider", "cat", "web", "ghost", "pumpkin"],
    newArrivals: ["pumpkin", "witch", "ghost", "bat", "spider", "web"],
    solutions: ["witch", "bat", "cat", "spider", "cauldron", "ghost"],
    look: ["potion", "ghost", "bat", "spider", "web", "pumpkin"],
    science: ["cauldron", "ghost", "witch", "spider", "web", "potion"],
    guide: ["potion", "cat", "bat", "ghost", "spider", "witch"],
    reassurance: ["web", "spider", "ghost", "cat", "bat", "witch"],
    product: ["cauldron", "web", "pumpkin", "ghost", "bat", "spider"],
    collectionBanner: ["witch", "bat", "web", "pumpkin", "ghost", "spider"],
    collection: ["pumpkin", "bat", "web", "spider", "witch", "ghost"],
    blog: ["ghost", "cat", "potion", "web", "bat", "spider"],
    article: ["ghost", "web", "cat", "witch", "pumpkin", "bat"],
    page: ["witch", "potion", "cat", "ghost", "web", "bat"],
    cart: ["pumpkin", "cat", "ghost", "potion", "web", "spider"],
    search: ["bat", "spider", "cauldron", "potion", "web", "ghost"],
    notFound: ["ghost", "witch", "bat", "web", "pumpkin", "potion"]
  };

  function getSectionRoots() {
    var roots = [];
    Array.prototype.forEach.call(main.children, function (child) {
      var isSectionWrapper = child.classList.contains("shopify-section") || child.id.indexOf("shopify-section-") === 0;
      var root = child.matches("section, article") ? child : child.querySelector(":scope > section, :scope > article");
      if (!root && isSectionWrapper) {
        root = Array.prototype.find.call(child.children, function (element) {
          return !/^(STYLE|SCRIPT|TEMPLATE)$/.test(element.tagName);
        }) || child;
      }
      if (root && !root.dataset.pcHalloweenDecor) roots.push(root);
    });
    return roots;
  }

  function getRecipe(section, index, carouselIndex) {
    if (section.matches(".hero")) return recipes.hero;
    if (section.matches(".cred")) return recipes.credibility;
    if (section.matches(".promo-banner")) return recipes.promo;
    if (section.matches("#concern")) return recipes.concern;
    if (section.matches("#banner, .banner")) return recipes.banner;
    if (section.matches(".product-carousel-section")) {
      return carouselIndex % 2 === 0 ? recipes.productsA : recipes.productsB;
    }
    if (section.matches("#brands")) return recipes.brands;
    if (section.matches("#spotlight")) return recipes.spotlight;
    if (section.matches("#ingredient")) return recipes.ingredient;
    if (section.matches("#new")) return recipes.newArrivals;
    if (section.matches("#solutions")) return recipes.solutions;
    if (section.matches("#look")) return recipes.look;
    if (section.matches("#science")) return recipes.science;
    if (section.matches("#guide")) return recipes.guide;
    if (section.matches(".reassure")) return recipes.reassurance;
    if (section.matches(".pdp-main, .main-product-section")) return recipes.product;
    if (section.matches(".collection-banner")) return recipes.collectionBanner;
    if (section.matches(".main-collection, .collection-hub-pregrid, .collection-hub-postgrid")) return recipes.collection;
    if (section.matches(".main-blog, .blog-grid-section")) return recipes.blog;
    if (section.matches(".main-article")) return recipes.article;
    if (section.matches(".main-page")) return recipes.page;
    if (section.matches(".main-cart")) return recipes.cart;
    if (section.matches(".main-search")) return recipes.search;
    if (section.matches(".main-404")) return recipes.notFound;

    var kinds = ["bat", "ghost", "pumpkin", "spider", "witch", "potion", "cat", "web", "cauldron"];
    return Array.from({ length: 6 }, function (_, slot) {
      return kinds[(index * 3 + slot * 2) % kinds.length];
    });
  }

  function applySlot(art, slot, delayIndex, sectionIndex, layerIndex) {
    Object.keys(slot).forEach(function (key) {
      if (key === "x" || key === "y" || key === "rotate") return;
      art.style.setProperty("--pc-art-" + key, slot[key]);
    });
    art.style.setProperty("--pc-art-entry-x", slot.x);
    art.style.setProperty("--pc-art-entry-y", slot.y);
    art.style.setProperty("--pc-art-entry-rotation", slot.rotate);
    art.style.setProperty("--pc-art-delay", (delayIndex * 105) + "ms");
    var motionDelay = ((sectionIndex * 0.47 + layerIndex * 0.61) % 3.4).toFixed(2);
    art.style.setProperty("--pc-motion-delay", "-" + motionDelay + "s");
  }

  function makeArt(stage, section, kind, layer, layerIndex, sectionIndex, delayIndex) {
    var art = document.createElement("span");
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    var use = document.createElementNS("http://www.w3.org/2000/svg", "use");
    var reference = "#pc-halloween-" + (kind === "bat" ? "bat-scroll" : kind);
    var slots = layer === "background" ? backgroundSlots : (
      section.matches(".hero") ? heroForegroundSlots : (
        section.matches(".cred") ? ribbonForegroundSlots : (
          section.matches(".pdp-main, .main-product-section") ? productForegroundSlots : foregroundSlots
        )
      )
    );

    art.className = "pc-halloween-scroll-art pc-halloween-scroll-art--" + kind + " pc-halloween-scroll-art--" + layer;
    applySlot(art, slots[layerIndex % slots.length], delayIndex, sectionIndex, layerIndex);
    svg.setAttribute("viewBox", viewBoxes[kind]);
    svg.setAttribute("focusable", "false");
    use.setAttribute("href", reference);
    use.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", reference);
    svg.appendChild(use);
    art.appendChild(svg);
    stage.appendChild(art);
    return art;
  }

  function makeStage(section, layer) {
    var stage = document.createElement("div");
    stage.className = "pc-halloween-scroll-stage pc-halloween-scroll-stage--" + layer;
    stage.setAttribute("aria-hidden", "true");
    section.appendChild(stage);
    return stage;
  }

  var found = [];
  var sceneBySection = typeof WeakMap !== "undefined" ? new WeakMap() : new Map();
  var decorations = [];
  var carouselIndex = 0;
  getSectionRoots().forEach(function (section, index) {
    var recipe = getRecipe(section, index, carouselIndex);
    if (section.matches(".product-carousel-section")) carouselIndex += 1;

    section.dataset.pcHalloweenDecor = "true";
    section.classList.add("pc-halloween-scroll-section");
    if (section.matches(".cred")) section.classList.add("pc-halloween-scroll-section--ribbon");

    var background = makeStage(section, "background");
    var foreground = makeStage(section, "foreground");
    var backgroundCount = Math.min(4, Math.max(2, recipe.length - 2));
    var foregroundCount = Math.min(2, Math.max(1, recipe.length - backgroundCount));
    recipe.slice(0, backgroundCount).forEach(function (kind, slotIndex) {
      decorations.push(makeArt(background, section, kind, "background", slotIndex, index, slotIndex));
    });
    recipe.slice(backgroundCount, backgroundCount + foregroundCount).forEach(function (kind, slotIndex) {
      decorations.push(makeArt(foreground, section, kind, "foreground", slotIndex, index, backgroundCount + slotIndex));
    });
    var scene = { section: section, background: background, foreground: foreground };
    found.push(scene);
    sceneBySection.set(section, scene);
  });

  if (!found.length) return;
  var reduced = Boolean(window.PC_REDUCED) || (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  if (reduced || !("IntersectionObserver" in window)) {
    decorations.forEach(function (art) { art.classList.add("is-visible"); });
    return;
  }

  // O(1) scene lookup via sceneBySection map avoids O(N) array search inside high-frequency observer callbacks.
  var sectionObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var scene = sceneBySection.get(entry.target);
      if (!scene) return;
      scene.isNearViewport = entry.isIntersecting;
      if (entry.isIntersecting) schedule();
    });
  }, { rootMargin: "16% 0px 16% 0px", threshold: 0 });
  found.forEach(function (scene) { sectionObserver.observe(scene.section); });

  var artObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle("is-visible", entry.isIntersecting);
      if (entry.isIntersecting) schedule();
    });
  }, { rootMargin: "16% 0px 16% 0px", threshold: 0 });
  decorations.forEach(function (art) { artObserver.observe(art); });

  var frame = 0;
  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(updateParallax);
  }

  // Batch all DOM reads (getBoundingClientRect) before DOM style writes (style.setProperty)
  // to avoid forced synchronous layout reflows (layout thrashing) during scroll animation frames.
  function updateParallax() {
    frame = 0;
    var viewport = window.innerHeight || 1;
    var activeUpdates = [];
    for (var i = 0; i < found.length; i++) {
      var scene = found[i];
      if (!scene.isNearViewport) continue;
      var rect = scene.section.getBoundingClientRect();
      var progress = (viewport * 0.5 - (rect.top + rect.height * 0.5)) * 0.13;
      var offset = Math.max(-58, Math.min(58, progress));
      activeUpdates.push(scene, (offset * 0.5).toFixed(1) + "px", (offset * 1.15).toFixed(1) + "px");
    }
    for (var j = 0; j < activeUpdates.length; j += 3) {
      var sc = activeUpdates[j];
      sc.background.style.setProperty("--pc-halloween-scroll-y", activeUpdates[j + 1]);
      sc.foreground.style.setProperty("--pc-halloween-scroll-y", activeUpdates[j + 2]);
    }
  }

  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
  schedule();
})();
